import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
    templateUrl: './blocking-dialog.component.html',
    styleUrls: ['./blocking-dialog.component.scss'],
    standalone: false
})
export class BlockingDialogComponent {

    constructor(
        public readonly dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: { message: string },
    ) { }

}
